RivalIQ.module('state', function (state, App, Backbone, Marionette, $, _) {

    'use strict';

    const product = state.product = new Backbone.Model();

    /**
     * Finds a plan by the specified identifier.
     * @param planId
     * @returns {*}
     */
    product.getPlanById = function (planId) {

        const me = this;
        const plans = me.get('plans');

        return _.find(plans, function (plan) {
            return (plan.id === planId);
        });
    };

    // Check if the user is on a page that should not be
    // obscured, regardless of status
    product.onAccessiblePage = function () {
        return window.location.pathname.match(/\/manage/) || window.location.pathname.match(/\/account\/user/);
    };

    /**
     * A property map transforming settings into view state, and view state
     * into persistence.
     * @type {*[]}
     */
    const statePropertyMap = [
        {
            settingProperty: 'csrfToken',
            path: 'app'
        },
        {
            settingProperty: 'metadata_version',
            path: 'app'
        },
        {
            settingProperty: 'urlBasepath'
        },
        {
            settingProperty: 'helpUrlBasePath'
        },
        {
            settingProperty: 'plans'
        },
        {
            settingProperty: 'defaultRedirectLocation'
        },
        {
            settingProperty: 'expiredTrialMaxVisits'
        },
        {
            settingProperty: 'trialExpiresSoonDaysLeft'
        },
        {
            settingProperty: 'customDashboardsWidgetLimit'
        },
        {
            settingProperty: 'customDashboardsListsWidgetLimit'
        },
        {
            settingProperty: 'defaultPlanId'
        },
        {
            settingProperty: 'trialerCalendlyUrl'
        }
    ];

    /**
     * Initializes product state from properties.
     * @param product
     * @param properties
     */
    function initializeProductFromProperties(product, properties) {

        state.utils.initializeState(null, null, statePropertyMap, product, properties);
    }

    (function () {

        let hasInitialized = false;

        product.initialize = function (properties) {

            if (hasInitialized) {

                throw 'not supported: product cannot be initialized more than once.';
            }

            initializeProductFromProperties(this, properties);

            hasInitialized = true;
        };

    }());

});
